/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
export const ClipboardCheckIconConfig = {
  name: 'ClipboardCheckIcon',
  height: 512,
  width: 384,
  svgPath: 'M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm121.2 231.8l-143 141.8c-4.7 4.7-12.3 4.6-17-.1l-82.6-83.3c-4.7-4.7-4.6-12.3.1-17L99.1 285c4.7-4.7 12.3-4.6 17 .1l46 46.4 106-105.2c4.7-4.7 12.3-4.6 17 .1l28.2 28.4c4.7 4.8 4.6 12.3-.1 17z',
  yOffset: '',
  xOffset: '',
  transform: ''
};
export default createIcon(ClipboardCheckIconConfig);
//# sourceMappingURL=clipboard-check-icon.js.map